import React from 'react';
import { Calendar, ArrowRight, Newspaper, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';
import PageHero, { Section, CTABlock } from '../components/PageHero';

const news = [
  { date: '10 Jan 2026', tag: 'NMC UPDATE', title: 'NMC Announces NExT Rollout Timeline for 2026 Batch', excerpt: 'The National Medical Commission has published updated guidelines for the introduction of NExT as the unified licensing exam, applicable to all MBBS graduates from 2026 onward.' },
  { date: '02 Jan 2026', tag: 'ADMISSIONS', title: '2026–27 Admissions Open at 64 Russian Government Universities', excerpt: 'Direct admissions have opened for the 2026–27 academic year. Students with a valid NEET qualification can now apply through Russian Education for guaranteed seats.' },
  { date: '20 Dec 2025', tag: 'STUDENT LIFE', title: 'Kazan Indian Students Win All-Russia Cultural Fest 2025', excerpt: 'Indian medical students at Kazan Federal University bag first prize at the All-Russia International Students Cultural Festival with Bollywood-classical fusion.' },
  { date: '15 Dec 2025', tag: 'FMGE', title: 'FMGE Dec 2025 Results: 42% Russian Alumni Pass Rate', excerpt: 'FMGE December 2025 saw Russian government-university graduates achieve an above-average 42% pass rate — higher than the national average for foreign MBBS graduates.' },
  { date: '01 Dec 2025', tag: 'POLICY', title: 'Russia Extends Student Visa Validity to 3 Years', excerpt: 'The Russian Ministry of Interior has extended student visa validity, reducing the annual renewal burden for foreign MBBS students in Russia.' },
  { date: '25 Nov 2025', tag: 'PARTNERSHIP', title: 'Russian Education Signs MOU with Bashkir State Medical University', excerpt: 'New MOU guarantees priority admissions and dedicated academic support for Indian students at BSMU, Ufa — one of Russia’s top medical universities.' },
];

export default function News() {
  return (
    <>
      <PageHero eyebrow="Latest Updates" title="News &" highlight="Announcements"
        subtitle="Stay updated on NMC guidelines, Russian medical university admissions, FMGE/NExT news and everything relevant to Indian MBBS aspirants."
        breadcrumbs={[{ label: 'News' }]} />

      <Section>
        <div className="space-y-5">
          {news.map((n, i) => (
            <article key={i} className="grid md:grid-cols-[100px_1fr] gap-5 bg-white rounded-2xl border border-border p-6 card-lift">
              <div className="flex md:flex-col items-center md:items-start gap-2 md:gap-1">
                <div className="w-14 h-14 rounded-xl bg-brand/10 text-brand flex items-center justify-center shrink-0">
                  <Newspaper className="w-6 h-6" />
                </div>
                <div className="text-[10px] font-bold uppercase tracking-widest text-brand mt-2">{n.tag}</div>
              </div>
              <div>
                <div className="flex items-center gap-1.5 text-xs text-muted-foreground"><Calendar className="w-3.5 h-3.5" /> {n.date}</div>
                <h3 className="font-serif text-xl md:text-2xl font-bold text-primary mt-2 leading-snug">{n.title}</h3>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{n.excerpt}</p>
                <a href="#" className="mt-3 inline-flex items-center gap-1 text-brand font-bold text-sm group">
                  Read More <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </Section>

      <CTABlock title="Subscribe for weekly updates" subtitle="Get NMC news, university announcements & seminar dates delivered to your inbox." cta="Subscribe Now" />
    </>
  );
}
